import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";
import { Role, RoleConverter } from "../role/role";
import { Locations, LocationsArrayConverter } from "../location/locations";

@JsonConverter
export class IdentityConverter implements JsonCustomConvert<Identity> {
	serialize() { }
	deserialize(data: any): Identity {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, Identity);
	}
}

@JsonConverter
export class IdentityArrayConverter implements JsonCustomConvert<Array<Identity>> {
	serialize() { }
	deserialize(data: any): Array<Identity> {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, Identity);
	}
}

@JsonConverter
export class IdentityListConverter implements JsonCustomConvert<IdentityListCount> {
	serialize() { }
	deserialize(data: any): IdentityListCount {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, IdentityListCount);
	}
}

@JsonObject("Identity")
export class Identity {
	@JsonProperty("id", String, true)
	id: string = "";
	@JsonProperty("verified", Boolean, true)
	verified: boolean = false;
	@JsonProperty("first_name", String, true)
	first_name: string = "";
	@JsonProperty("last_name", String, true)
	last_name: string = "";
	@JsonProperty("email", String, true)
	email: string = "";
	@JsonProperty("phone_number", String, true)
	phone_number: string = "";
	@JsonProperty("last_update", Number, true)
	last_update: number = 0;
	@JsonProperty("registered_at", Number, true)
	registered_at: number = 0;
	@JsonProperty("marketing_consent", Boolean, true)
	marketing_consent: boolean = false;
	@JsonProperty("profile_consents", Boolean, true)
	profile_consents: boolean = false;
	@JsonProperty("strategy", String, true)
	strategy: string = "";
}

@JsonObject("IdentityListCount")
export class IdentityListCount {
	@JsonProperty("count", Number, true)
	count: number = 0;
	@JsonProperty("data", IdentityArrayConverter, true)
	data: Array<Identity> = new Array<Identity>();
}


@JsonObject("IdentityListArray")
export class IdentityListArray extends BaseResponse {
	@JsonProperty("data", IdentityArrayConverter, true)
	data: Identity = new Identity();
}
@JsonObject("IdentityListData")
export class IdentityListData extends BaseResponse {
	@JsonProperty("data", IdentityListConverter, true)
	data: IdentityListCount = new IdentityListCount();
}

@JsonObject("IdentityArray")
export class IdentityArray extends BaseResponse {
	@JsonProperty("data", IdentityArrayConverter, true)
	data: Array<Identity> = new Array<Identity>();
}